module.exports = __webpack_public_path__ + "img/car_17.32c11666.jpg";